import React, { useEffect, useRef } from 'react';
import { FiX } from 'react-icons/fi';
import './style.css';

export default function Modal({ isOpen, onClose, title, children, closeOnOverlayClick = true, size = 'md' }) {
  const isClosingByBack = useRef(false);
  const modalIdRef = useRef(null);

  if (!modalIdRef.current) {
    modalIdRef.current = `modal-${Math.random().toString(36).substr(2, 9)}`;
  }

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      const scrollY = window.scrollY;

      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';

      return () => {
        document.removeEventListener('keydown', handleEsc);
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';

        const top = document.body.style.top;
        document.body.style.top = '';
        window.scrollTo(0, parseInt(top || '0') * -1);
      };
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);


  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={closeOnOverlayClick ? onClose : undefined}>
      <div className={`modal-container modal-${size}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close-button" onClick={onClose}>
            <FiX size={24} />
          </button>
        </div>
        <div className="modal-content">
          {children}
        </div>
      </div>
    </div>
  );
}
